
import React from 'react';
import Dashboard from './Dashboard';
import DashboardLayout from '@/components/layout/DashboardLayout';

const Index = () => {
  return (
    <DashboardLayout>
      <Dashboard />
    </DashboardLayout>
  );
};

export default Index;
